import { WizardStepMetadataProps } from '@philips-internal/oswald-ui-components/lib/components/wizard/wizard/wizard-utils';

export class WizardUtils {

  /**
   * @param steps Record<string, WizardContextStep>
   * @param to step identifier
   * @param from step identifier
   * @returns true if 'to' is a step before 'from'
   */
  static isPreviousStep(steps: Record<string, WizardStepMetadataProps>, to = '', from: string): boolean {
    const stepsId = Object.keys(steps);
    const originIndex = stepsId.indexOf(from);
    const destinationIndex = stepsId.indexOf(to);

    if(originIndex === -1 || destinationIndex === -1) {
      throw Error('Step index not found!');
    }

    return originIndex > destinationIndex;
  }

  /**
   * @param steps Record<string, WizardStepMetadataProps>
   * @param to step identifier
   * @returns true if 'to' is the last step
   */
  static isLastStep(steps: Record<string, WizardStepMetadataProps>, to = ''): boolean {
    const stepsId = Object.keys(steps);
    const destinationIndex = stepsId.indexOf(to);

    if(destinationIndex === -1) {
      throw Error('Step index not found!');
    }

    return (stepsId.length - 1) === destinationIndex;
  }
}